// @import "~@govbr-ds/core/src/components/header-link/header-link";

:host {
  display: block;
}
